module.exports = __webpack_public_path__ + "img/icon-privacy-security.26fe8db1.svg";